var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type === "spinner"
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-center align-items-center" },
          [
            _c("i", {
              staticClass: "fa fa-circle-o-notch fa-spin text-center",
              staticStyle: { "font-size": "85px" }
            })
          ]
        )
      : _c("div", { staticClass: "preloader-bounce--wrapper" }, [
          _c("div", { staticClass: "preloader-bounce" }, [
            _c("div", { staticClass: "loading" }, [
              _c("div", { staticClass: "preloader-bounce--bounceball" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "preloader-bounce--text text-uppercase" },
                [
                  _c("bold-words", {
                    attrs: {
                      word: {
                        text: _vm.text
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a8eb6a0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a8eb6a0","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./app/Shared/Resources/Assets/js/components/base/BaseLoadingAnimation.vue
// module id = 715
// module chunks = 0